import Service from "./base";
import { GoogleTagManager } from "../utils/tagManagerGoogle";
import { isTestDomain } from "../utils/uri";
import { DriveStore } from "../store/reducers";
import { observeStore } from "../utils/store";

export default class GTMService extends Service {

    private gtm?: GoogleTagManager = undefined;

    constructor(
        private readonly store: DriveStore,
        private readonly win: Window,
        private readonly doc: Document
    ) {
        super();

        observeStore(this.store, state => state.data.serverFlags, () => this.initialize());
    }

    initialize () {
        if (isTestDomain(this.win.location.host)) {
            return false;
        }

        let serverFlags: number = this.store.getState().data.serverFlags || 0;
        let isThirdPartyAllowed = (serverFlags & 1) === 1;

        if (!isThirdPartyAllowed) {
            this.destroy();
            return false;
        }

        if (this.gtm) {
            return false;
        }

        this.gtm = new GoogleTagManager(this.doc, this.win);
        return true;
    }

    setDimensions (dimensions: ITypedHash<string | Date | number>) {
        if (this.gtm) {
            this.gtm.setDimensions(this.win, dimensions);
        }
    }

    collectData() {
        let systemSettings = this.store.getState().systemSettings;
        this.setDimensions({
            resellerInfo: systemSettings?.resellerInfo?.erp || ""
        });
    }

    destroy () {
        if (this.gtm) {
            this.gtm.destroy();
            delete this.gtm;
        }
    }
}